import {Component, Input} from "@angular/core";
import {AbstractControl, UntypedFormControl} from "@angular/forms";

@Component({
    selector: 'app-input-checkbox',
    template: `
      <div class="custom-cb mr-2">
          <label class="checkbox-container" [for]="name">
              <input type="checkbox" [formControl]="formControl" [tabindex]="tabIndex" [id]="name"/>
              <span class="checkbox"></span>
              <span [innerHtml]="text"></span>
          </label>
      </div>
  `,
    styleUrls: [],
    standalone: false
})

export class InputCheckbox {
  @Input() control: AbstractControl | UntypedFormControl;
  @Input() name: string = '';
  @Input() text: string = '';
  @Input() disabled = false;
  @Input() autoFocus: boolean;
  @Input() tabIndex: number;

  get formControl() {
    return this.control as UntypedFormControl;
  }
}